import React from 'react';
import styled from 'styled-components';
import { ICountryLanguageEntity } from '../../../actions/DataServiceEntities.g';

interface StoreLocationProps {
    storeRegion: string;
    handleChange: any;
    state: string;
    handleClick: any;
    regionList: ICountryLanguageEntity[] | undefined;
    displayState: boolean;
    stateList: Object[];
    resources: any;
}

export const StoreLocationSelector: React.FC<StoreLocationProps> = ({
    storeRegion,
    handleChange,
    handleClick,
    state,
    regionList,
    displayState,
    stateList,
    resources
}) => {
    const LocationSelector = styled.div`
        display: flex;
        width: 100%;
        margin-bottom: 81.5px;
        align-items: flex-end;

        @media (max-width: 750px) {
            flex-direction: column;
            align-items: center;
        }
    `;
    const SelectWrapper = styled.div`
        width: 28%;
        margin-right: 10px;

        @media (max-width: 750px) {
            margin-right: 0xp;
            width: 65%;
            margin-bottom: 16px;
        }

        @media (max-width: 478px) {
            width: 90%;
        }
    `;

    // const SelectLabel = styled.label`
    //     font-size: .8em;
    //     padding: 0 0 4px 6px;
    //     color: #212225;
    //     font-weight: 300
    //     line-height: 1.45;
    //     font-family: Ensign:Sans
    // `;

    // const StoreLocatorSelect = styled.select`
    //     height: 40px;
    //     width: 100%;
    //     background: #ffffff;
    //     border: 1px solid #878a8c;
    //     border-radius: 2px;
    //     color: #0b6081;
    //     font-size: 16px;
    // `;

    // const StyledOption = styled.option`
    //     background: #fff;
    //     font-size: 14px;
    //     font-weight: 400;
    //     font-family: Ensign:Sans;
    //     line-height: 1.45;
    //     color: #212225;
    // `;

    return (
        <LocationSelector>
            <SelectWrapper>
                <label className='SelectLabel' htmlFor=''>
                    {resources.storeLocatorCountryLabel}
                </label>
                <select
                    className='StoreLocatorSelect'
                    name='country'
                    id=''
                    value={storeRegion}
                    onChange={e => handleChange(e.target.value)}
                >
                    <option className='StyledOption' value='' disabled selected>
                        {resources.defaultDropdown}
                    </option>
                    {regionList ? (
                        regionList.map(region => {
                            return (
                                <option className='StyledOption' value={region.countryRegionId} key={region.Id}>
                                    {region.CountryName}
                                </option>
                            );
                        })
                    ) : (
                        <option className='StyledOption' value='USA'>
                            United States
                        </option>
                    )}
                </select>
            </SelectWrapper>
            {displayState ? (
                <SelectWrapper>
                    <label className='SelectLabel' htmlFor=''>
                        {resources.storeLocatorStateLabel}
                    </label>
                    <select className='StoreLocatorSelect' name='state' id='' value={state} onChange={e => handleClick(e.target.value)}>
                        <option className='StyledOption' value='' disabled selected>
                            {resources.defalutDropdown}
                        </option>
                        {stateList.map((state: any) => {
                            return (
                                <option className='StyledOption' value={state.abbreviation} key={state.name}>
                                    {state.name}
                                </option>
                            );
                        })}
                    </select>
                </SelectWrapper>
            ) : null}
        </LocationSelector>
    );
};
